export default "__VITE_ASSET__DNIm6MpM__"